import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { API_URI } from "../Common/data";
import Loader from "../loader/Loader";

const AddOnServices = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [theaterData, setTheaterData] = useState(null);
  const [addOnServices, setAddOnServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [feeBreakdown, setFeeBreakdown] = useState({
    baseAmount: 0,
    cgst: 0,
    sgst: 0,
    platformFee: 0,
    gstInclusiveAmount: 0,
    grandTotal: 0
  });

  //  API Se Data Fetch Karna
  const fetchBookingsDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URI}/booking/single/${id}`);
      if (response.status === 200) {
        const data = response.data.data;
        setTheaterData(data?.theaterId);
        // setAddOnServices(data?.theaterId?.services || []);
        const subLocationId = data?.theaterId?.subLocationId;
        // console.log(data?.theaterId);

        // STEP 2: Fetch add-on services using subLocationId
        if (subLocationId) {
          const servicesRes = await axios.get(
            `${API_URI}/service-category/sublocation/${subLocationId}`
          );
          if (servicesRes.status === 200) {
            const categories = servicesRes.data?.data || [];
            const allServices = categories.flatMap((cat) => {
              return cat.services.map((service) => ({
                ...service,
                categoryName: cat.name,
                categoryId: cat._id,
                image: cat.image
              }));
            });

            setAddOnServices(allServices);
          } else {
            setAddOnServices([]);
          }
        } else {
          setAddOnServices([]);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response?.data?.message || "Failed to fetch booking details!"
      );
    }
  };

  useEffect(() => {
    fetchBookingsDetails();
  }, []);

  //  Service Select/Deselect Karna
  const handleServiceToggle = (service) => {
    const isSelected = selectedServices.find(
      (item) => item._id === service._id
    );

    if (isSelected) {
      const updatedList = selectedServices.filter(
        (item) => item._id !== service._id
      );
      setSelectedServices(updatedList);
    } else {
      setSelectedServices([...selectedServices, service]);
    }
  };

  //  Total Price Calculate Karna
  // useEffect(() => {
  //   const total = selectedServices.reduce(
  //     (sum, service) => sum + (service.price || 0),
  //     0
  //   );
  //   setTotalAmount(total);
  // }, [selectedServices]);
  useEffect(() => {
    const total = selectedServices.reduce(
      (sum, service) => sum + (service.price || 0),
      0
    );

    const baseAmount = +(total / 1.18).toFixed(2); // Price inclusive of 18% GST
    const cgst = +(baseAmount * 0.09).toFixed(2);
    const sgst = +(baseAmount * 0.09).toFixed(2);
    const platformFee = +(total * 0.02).toFixed(2); // 2% on total (incl. GST)
    const grandTotal = +(total + platformFee).toFixed(2);

    setTotalAmount(grandTotal);

    setFeeBreakdown({
      baseAmount,
      cgst,
      sgst,
      platformFee,
      gstInclusiveAmount: total,
      grandTotal
    });
  }, [selectedServices]);
  const handleProceedToCheckout = async () => {
    const token = localStorage.getItem("cine_userToken");
    if (!token) return toast.error("Please Login First.");

    if (selectedServices.length === 0) {
      return toast.error("Please select at least one service.");
    }

    try {
      setLoading(true);

      //  Step 1: Send selected services for pre-booking
      const preBookingPayload = {
        bookingId: id,
        services: selectedServices.map((service) => ({
          serviceId: service._id,
          price: service.price,
          quantity: 1,
          totalAmount: service.price
        }))
      };

      const preBookingResponse = await axios.post(
        `${API_URI}/booking/pre-booking/create`,
        preBookingPayload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (preBookingResponse.status !== 200) {
        setLoading(false);
        return toast.error("Failed to save pre-booking services.");
      }

      //  Step 2: Initiate Payment via PhonePe
      const paymentPayload = {
        name: preBookingResponse.data.data.bookingName,
        merchantUserId: id,
        amount: totalAmount.toFixed(2).toString()
      };

      const paymentRes = await axios.post(
        `${API_URI}/phonepe/services/payment`,
        paymentPayload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setLoading(false);

      if (paymentRes.status === 200) {
        window.location.href = paymentRes.data;
      } else {
        toast.error("Payment initiation failed.");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Something went wrong. Try again!");
    }
  };

  if (loading) return <Loader />;

  return (
    <div>
      <Navbar />
      <section className="addon-page">
        <div className="addon-page__orb addon-page__orb--one"></div>
        <div className="addon-page__orb addon-page__orb--two"></div>

        <div className="addon-layout">
          <div className="addon-main">
            <section className="addon-hero">
              <p className="addon-hero__eyebrow">Customize Your Booking</p>
              <h1>Add finishing touches to your celebration.</h1>
              <p className="addon-hero__text">
                Choose food, decor, surprises, or experience upgrades that fit
                your booking. Select only what you want and continue when you’re
                ready.
              </p>
            </section>

            {theaterData && (
              <section className="addon-theater">
                <div className="addon-theater__copy">
                  <p className="addon-theater__eyebrow">Linked Booking</p>
                  <h2>{theaterData.name}</h2>
                  <p>{theaterData.cancellationPolicy}</p>
                </div>
                <div className="addon-theater__media">
                  <img
                    src={theaterData.imageUrls?.[0]}
                    alt={theaterData.name}
                  />
                </div>
              </section>
            )}

            <section className="addon-services">
              <div className="addon-services__topbar">
                <div>
                  <p className="addon-services__eyebrow">Available Add-Ons</p>
                  <h3>Pick the extras you want</h3>
                </div>
                <div className="addon-services__count">
                  {addOnServices.length} options
                </div>
              </div>

              {addOnServices.length > 0 ? (
                <div className="addon-services__grid">
                  {addOnServices.map((service) => {
                    const isSelected = selectedServices.some(
                      (item) => item._id === service._id
                    );

                    return (
                      <article
                        key={service._id}
                        className={`addon-service-card ${
                          isSelected ? "is-selected" : ""
                        }`}
                      >
                        <div className="addon-service-card__media">
                          <img
                            src={service.image || service.imageUrls?.[0]}
                            alt={service.name}
                          />
                        </div>

                        <div className="addon-service-card__body">
                          <p className="addon-service-card__category">
                            {service.categoryName || "Cine Celebrate Add-On"}
                          </p>
                          <h4>{service.name}</h4>
                          <p className="addon-service-card__description">
                            {service.description}
                          </p>

                          <div className="addon-service-card__footer">
                            <strong>₹{service.price || 0}</strong>
                            <Form.Check
                              type="checkbox"
                              id={`addon-${service._id}`}
                              label={isSelected ? "Selected" : "Select"}
                              checked={isSelected}
                              onChange={() => handleServiceToggle(service)}
                            />
                          </div>
                        </div>
                      </article>
                    );
                  })}
                </div>
              ) : (
                <div className="addon-services__empty">
                  No add-on services are available for this booking.
                </div>
              )}
            </section>
          </div>

          <aside className="addon-summary">
            <div className="addon-summary__card">
              <p className="addon-summary__eyebrow">Selected Services</p>
              <h3>
                {selectedServices.length ? "Checkout summary" : "Nothing selected yet"}
              </h3>

              <div className="addon-summary__list">
                {selectedServices.length > 0 ? (
                  selectedServices.map((service) => (
                    <div key={service._id} className="addon-summary__item">
                      <span>{service.name}</span>
                      <strong>₹{service.price}</strong>
                    </div>
                  ))
                ) : (
                  <div className="addon-summary__empty">
                    Pick one or more add-ons from the list to continue.
                  </div>
                )}
              </div>

              <div className="addon-summary__fees">
                <div>
                  <span>Base Price</span>
                  <strong>₹{feeBreakdown.baseAmount}</strong>
                </div>
                <div>
                  <span>CGST (9%)</span>
                  <strong>₹{feeBreakdown.cgst}</strong>
                </div>
                <div>
                  <span>SGST (9%)</span>
                  <strong>₹{feeBreakdown.sgst}</strong>
                </div>
                <div>
                  <span>Platform Fee</span>
                  <strong>₹{feeBreakdown.platformFee}</strong>
                </div>
              </div>

              <div className="addon-summary__total">
                <span>Grand Total</span>
                <strong>₹{feeBreakdown.grandTotal}</strong>
              </div>

              <Button
                className="addon-summary__cta"
                disabled={selectedServices.length === 0}
                onClick={handleProceedToCheckout}
              >
                Proceed to Checkout
              </Button>
            </div>
          </aside>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AddOnServices;
